const variables: { [key: string]: { [key: string]: string } } = {
  production: {
    REACT_APP_FOTOM_URL: "https://fotom4.cheerz.com",
    REACT_APP_FOTOM_SELECTION_URL: "https://fotom.cheerz.com",
    REACT_APP_KUSTOM_BACKEND_URL: "https://kustom.cheerz.com",
  },
  staging: {
    REACT_APP_FOTOM_URL: "https://fotom-staging.cheerz.com",
    REACT_APP_FOTOM_SELECTION_URL: "https://fotom-staging.cheerz.com",
    REACT_APP_KUSTOM_BACKEND_URL: "https://kustom-staging.cheerz.com",
  },
};

export function getVariableByEnv(variableName: string): string {
  const releaseStage = getMetaContent("cheerz-env");
  const varByEnv = releaseStage && variables[releaseStage] && variables[releaseStage][variableName];

  const returnVar = varByEnv || process.env[variableName];
  if (!returnVar) {
    throw new Error(`Missing env ${variableName}`);
  }

  return returnVar;
}

export const getMetaContent = (name: string): string | undefined => {
  const metaElement = document.querySelector<HTMLMetaElement>(`meta[name=${name}]`);
  if (!metaElement) {
    return;
  }

  return metaElement.content;
};
